import type { ReactNode } from "react";
import { common } from "../copy/common.js";

/**
 * One screen, one task, one way out (docs/UX.md §1).
 *
 * The Shell puts the main navigation exactly where a thumb rests on a tablet.
 * During a practice round that is a second, unintended exit: a mistap leaves
 * PracticeScreen, the answers of the round live in its local state and have
 * not been posted yet, so the round is gone although nobody meant to stop
 * (issue #2). A round that ends this way is cheap -- the Leitner state hangs
 * on the word, not on the round -- but it should be a decision, and the screen
 * already carries «Abbrechen» for that.
 */
export function FocusLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh">
      <a href="#inhalt" className="skip-link">
        {common.nav.skipToContent}
      </a>
      <main
        id="inhalt"
        className="mx-auto w-full max-w-2xl px-4 pt-6 pb-12 sm:px-6 sm:pt-8 lg:pt-10 lg:pb-16 print:max-w-none print:p-0"
      >
        {children}
      </main>
    </div>
  );
}
